import React, { useEffect, useMemo, useState } from "react"
import { createStyles, styled } from "@design-system/core"
import { __DEV__ } from "@design-system/utils"
import { LayerGroups } from "./LayerGroups"
import { getLayers, subscribeLayersChange } from "./layers"
import { PortalHostProps, PortalLayer } from "./types"

const styles = createStyles(() => ({
  root: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
  },
}))

export function PortalHost(props: PortalHostProps) {
  const { zIndex } = props
  const [layers, setLayers] = useState(getLayers())

  useEffect(() => subscribeLayersChange(() => setLayers(getLayers())), [])

  const [fixedLayers, inFlowLayers] = useMemo(() => {
    const _fixedLayers: PortalLayer[] = []
    const _inFlowLayers: PortalLayer[] = []
    layers.forEach((layer) => {
      if (layer.fixed) {
        _fixedLayers.push(layer)
      } else {
        _inFlowLayers.push(layer)
      }
    })
    return [_fixedLayers, _inFlowLayers]
  }, [layers])

  if (!layers.length) {
    return null
  }

  return (
    <styled.div nativeID="gds-layers" style={[styles.root, { zIndex }]}>
      <LayerGroups layers={fixedLayers} isFixed />
      <LayerGroups layers={inFlowLayers} isFixed={false} />
    </styled.div>
  )
}

if (__DEV__) {
  PortalHost.displayName = "PortalHost"
}
